import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import ImgOrVideoCards from './ImgOrVideoCards';

const styles = theme => ({ 
  eventGalleryItemWrapper: {
  padding: '0px 35px',
  [theme.breakpoints.only('xs')]: {
    padding: 0
}
 }
     
})


class EventGalleryOrVideos extends Component {
  render() {
    const { classes, items, isVideo, active } = this.props;
    return (
      <div className={classes.eventGalleryItemWrapper}>
        <ImgOrVideoCards items={items} isVideo={isVideo} active={active} />
      </div>    
    );
  }
}

export default withStyles(styles)(EventGalleryOrVideos);
